import { AppCardMediaOverlay } from '@app/components/base/app-card';
import { webApi } from '@mi-front/api-clients';
import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { FRAGMENT_CARD_PADDING_X } from '../constants';
import { FragmentCardDurationPill } from './FragmentCardDurationPill';
import { FragmentCardStatuses, hasStatusesContent } from './FragmentCardStatuses';
import { FragmentCardTimePill } from './FragmentCardTimePill';
import { FragmentMediaPill } from './FragmentMediaPill';

/**
 * Renders fragment overlay pills (time, statuses, duration) on top of
 * any media content (waveform, poster, etc.) using AppCardMediaOverlay corners.
 */
export function FragmentCardMediaOverlay({
  fragment,
  children,
  sx,
}: {
  fragment: webApi.FragmentListItemDto;
  children: ReactNode;
  sx?: SxProps<Theme>;
}) {
  const showStatuses = hasStatusesContent({
    uploadStatuses: fragment.uploadStatuses,
    externalDelivery: fragment.externalDelivery,
    publishedPlatforms: fragment.publishedPlatforms,
    externalDeliveryStartedAt: fragment.externalDeliveryStartedAt,
    contentAiCreatedAt: fragment.contentAiCreatedAt,
  });

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%', ...sx }}>
      {children}
      <AppCardMediaOverlay
        overlayPosition="top-left"
        inset={1}
        sx={{ left: FRAGMENT_CARD_PADDING_X }}
      >
        <FragmentCardTimePill fragment={fragment} />
      </AppCardMediaOverlay>
      {showStatuses ? (
        <AppCardMediaOverlay
          overlayPosition="top-right"
          inset={1}
          sx={{ right: FRAGMENT_CARD_PADDING_X }}
        >
          <FragmentMediaPill>
            <FragmentCardStatuses
              uploadStatuses={fragment.uploadStatuses}
              externalDelivery={fragment.externalDelivery}
              publishedPlatforms={fragment.publishedPlatforms}
              externalDeliveryStartedAt={fragment.externalDeliveryStartedAt}
              contentAiCreatedAt={fragment.contentAiCreatedAt}
            />
          </FragmentMediaPill>
        </AppCardMediaOverlay>
      ) : null}
      <AppCardMediaOverlay
        overlayPosition="bottom-right"
        inset={1}
        sx={{ right: FRAGMENT_CARD_PADDING_X }}
      >
        <FragmentCardDurationPill fragment={fragment} />
      </AppCardMediaOverlay>
    </Box>
  );
}
